import { render, staticRenderFns } from "./ListSection.vue?vue&type=template&id=b4606a32&scoped=true&"
import script from "./ListSection.vue?vue&type=script&lang=js&"
export * from "./ListSection.vue?vue&type=script&lang=js&"
import style0 from "./ListSection.vue?vue&type=style&index=0&id=b4606a32&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4606a32",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2065084294/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b4606a32')) {
      api.createRecord('b4606a32', component.options)
    } else {
      api.reload('b4606a32', component.options)
    }
    module.hot.accept("./ListSection.vue?vue&type=template&id=b4606a32&scoped=true&", function () {
      api.rerender('b4606a32', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ListSection.vue"
export default component.exports